import React, { useEffect, useRef, useState } from "react";
import { createRoot } from "react-dom/client";
import { Container, Mask, Ctrls, BtnPrev, BtnNext, BtnClose } from "./ImageViewer.styled";
import IconMinus from "./icons/IconMinus";
import IconPlus from "./icons/IconPlus";
import IconRestore from "./icons/IconRestore";
import IconRotateReverse from "./icons/IconRotateReverse";
import IconRotate from "./icons/IconRotate";
import IconChevronLeft from "./icons/IconChevronLeft";
import IconChevronRight from "./icons/IconChevronRight";
import IconClose from "./icons/IconClose";

const modalRoot = document.querySelector("#image-picker");

let initX;
let initY;
let lastX;
let lastY;

const minScale = 0.2;
const maxScale = 4;
const scaleStep = 0.1;

function clamp(min, max, value) {
  return Math.max(Math.min(max, value), min);
}

export const ImageViewerDialog = ({ images = [], onClose }) => {
  const containerRef = useRef();
  const ref = useRef();

  const [idx, setIdx] = useState(0);
  const [scale, setScale] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [tx, setTx] = useState(0);
  const [ty, setTy] = useState(0);
  const len = images.length;

  useEffect(() => {
    window.document.body.style.overflow = "hidden";
  }, []);

  // useEffect(() => {
  //   if (!containerRef.current) return;
  //   window.addEventListener('wheel', handleWheel);

  //   return () => {
  //     window.removeEventListener('wheel', handleWheel);
  //   }
  // }, [containerRef]);

  function handleWheel(e) {
    // e.stopPropagation();
    // e.preventDefault();
    const sign = Math.sign(e.deltaY);
    handleScale(-sign);
    // const s = clamp(minScale, maxScale, scale - Math.sign(e.deltaY) * scaleStep);
    // setScale(s);
  }

  function handleScale(sign) {
    const s = clamp(minScale, maxScale, scale + sign * scaleStep);
    setScale(s);
  }

  function handleRotate(sign) {
    // const r = (rotation + 90 * sign) % 360; // 过渡旋转有问题
    const r = rotation + 90 * sign;
    ref.current.style.transition = "transform 0.3s";
    setRotation(r);
  }

  function handleMouseDown(e) {
    e.stopPropagation();
    e.preventDefault();
    ref.current.style.transition = "none";

    initX = e.clientX;
    initY = e.clientY;

    lastX = e.clientX;
    lastY = e.clientY;

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  }

  function handleMouseMove(e) {
    e.stopPropagation();
    e.preventDefault();

    const { clientX, clientY } = e;

    const incX = clientX - lastX;
    const incY = clientY - lastY;

    setTx(tx + incX);
    setTy(ty + incY);
  }

  function handleMouseUp(e) {
    e.stopPropagation();
    e.preventDefault();

    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  }

  function handleChangeIdx(inc) {
    if (inc < 0 && idx === 0) return;
    if (inc > 0 && idx === len - 1) return;
    const _idx = (idx + inc) % len;
    // console.log(_idx)
    reset();
    setIdx(_idx);
  }

  function reset() {
    setTx(0);
    setTy(0);
    setScale(1);
    setRotation(0);
  }

  return (
    <Container className="rcc" onWheel={handleWheel} ref={containerRef}>
      <Mask
        onClick={() => {
          onClose();
        }}
      ></Mask>

      <BtnClose className="rcc" onClick={onClose}>
        <IconClose />
      </BtnClose>

      {len > 1 && idx > 0 && (
        <BtnPrev className="rcc" onClick={() => handleChangeIdx(-1)}>
          <IconChevronLeft />
        </BtnPrev>
      )}

      {len > 1 && idx < len - 1 && (
        <BtnNext className="rcc" onClick={() => handleChangeIdx(1)}>
          <IconChevronRight />
        </BtnNext>
      )}

      <img
        src={images[idx]}
        ref={ref}
        onMouseDown={handleMouseDown}
        style={{
          transform: `translate3d(${tx}px, ${ty}px, 0) scale(${scale}) rotate(${rotation}deg)`,
          maxHeight: "90%",
        }}
        onTransitionEnd={() => {
          ref.current.style.transition = "none";
          setRotation(rotation % 360);
        }}
      />

      <Ctrls className="flexr">
        <div className="icon-wrap" onClick={() => handleScale(-1)}>
          <IconMinus />
        </div>
        <div className="icon-wrap" onClick={() => handleScale(1)}>
          <IconPlus />
        </div>
        <div
          className="icon-wrap"
          onClick={() => {
            reset();
          }}
        >
          <IconRestore />
        </div>
        <div className="icon-wrap" onClick={() => handleRotate(-1)}>
          <IconRotateReverse />
        </div>
        <div className="icon-wrap" onClick={() => handleRotate(1)}>
          <IconRotate />
        </div>
      </Ctrls>
    </Container>
  );
};

const ImageViewer = ({ images, onClose = () => {} }) => {
  const root = createRoot(modalRoot);
  root.render(
    <ImageViewerDialog
      visible={true}
      onClose={() => {
        root.unmount();
        onClose();

        window.document.body.style.overflow = "unset";
      }}
      images={images}
    />
  );
};

export default ImageViewer;
